<div class="container-fluid" class="{{ loading ? 'disable' : ''}}">
    <div id="header" class="row">
        <div class="col-12 p-0 d-flex justify-content-between align-items-center">
            <div routerLink="/pages/dashboard" id="header-leftside" class="d-flex align-items-center">
                <div id="header-logo">
                </div>
                <div id="header-title" pTooltip="{{versionTooltip}}" tooltipZIndex="9999999" appendTo="body"
                    tooltipPosition="bottom" [escape]="false" showDelay="1000" hideDelay="1750">
                    {{title}}
                </div>
            </div>
            <div id="header-centralside">
                <div class="d-flex">
                    <a *ngFor="let item of items" class="py-3" routerLink="{{'/pages/'+ item.link}}"
                        >{{ item.label | translate}}
                    </a>
                </div>
            </div>
            <div id="header-rightside" class="d-flex align-items-center">
                <div class="position-relative position-button"
                    *ngIf="canShowNewPAI || canShowNewWork || canShowNewWorkers || canShowNewBudget">
                    <mapfre-auditlib-button type="inverted" [popup]="true" class="padding-right-40"
                        (click)="showPopupNew = !showPopupNew">
                        <span class="pe-2">+</span>
                        {{ 'NEW' | translate }}
                    </mapfre-auditlib-button>
                    <mapfre-auditlib-popup class="margin-header" [(display)]="showPopupNew">
                        <div class="content">
                            <ul class="menu-list">
                                <li class="cursor-pointer" *ngIf="canShowNewPAI"
                                    (click)="goRoute('/pages/planning/pais/create')">
                                    {{'HEADER.NEW_PAI' | translate}}
                                </li>
                                <li class="cursor-pointer" *ngIf="canShowNewWork"
                                    (click)="goRoute('/pages/works/create')">
                                    {{'HEADER.NEW_WORK' | translate}}
                                </li>
                                <li class="cursor-pointer" *ngIf="canShowNewWorkers"
                                    (click)="goRoute('/pages/planning/new-workers/create')">
                                    {{'HEADER.NEW_WORKERS' | translate}}
                                </li>
                                <li class="cursor-pointer" *ngIf="canShowNewBudget"
                                    (click)="goRoute('/pages/planning/new-budget/create')">
                                    {{'HEADER.NEW_BUDGET' | translate}}
                                </li>
                            </ul>
                        </div>
                    </mapfre-auditlib-popup>
                </div>
                <svg preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg" (click)="showProfile()"
                    xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40" viewBox="0 0 500 500">
                    <circle cx="255" cy="255" r="230" />
                    <text x="255" y="246" dy="0.4em" text-anchor="middle" fill="var(--greyish-brown)" style="dominant-baseline:auto"
                        font-size="180" font-weight="700" font-family="mapfre-text">
                        {{ userFirstLetters }}</text>
                </svg>
                <div class="position-relative language-popup margins-popup">
                    <span class="ms-2 color-white cursor-pointer"
                        (click)="displayLanguageModal = !displayLanguageModal">{{currentLang}}</span>
                    <mapfre-auditlib-popup [(display)]="displayLanguageModal">
                        <div class="d-flex">
                            <button (click)="displayLanguageModal = false" class="no-styles ms-auto padding-button"><i
                                    class="icon icon-24-px-menu-cerrar"></i></button>
                        </div>
                        <ul class="menu-list-flags">
                            <li *ngFor="let lang of availableLangs" class="cursor-pointer d-flex align-items-center ellipsis-100"
                                (click)="changeLanguage(lang?.code)">
                                <div class="flag-style"
                                    [ngStyle]="{'background-image':'url(' + lang?.img + ')','height':20+'px'}">
                                </div>
                                {{lang?.label | translate}}
                            </li>
                        </ul>
                    </mapfre-auditlib-popup>
                </div>
                <i title="{{'HEADER.EXIT' | translate}}"
                    pTooltip="{{versionTooltip}}" tooltipZIndex="9999999" appendTo="body" tooltipPosition="bottom"
                    [escape]="false" showDelay="1000" hideDelay="1750"
                    class="ms-2 pi pi-power-off font-large cursor-pointer" (click)="displayModal=true"></i>
            </div>
        </div>
    </div>
</div>

<mapfre-auditlib-modal [(visible)]="displayModal">
    <div class="modal-content">
        <h3 translate class="mt-0">HEADER.LOGOUT</h3>
        <div class="padding-question" translate>FLOW.QUESTION</div>
        <mapfre-auditlib-button (click)="onLogoutClick()">
            <span translate class="white">HEADER.EXIT</span>
        </mapfre-auditlib-button>
    </div>
</mapfre-auditlib-modal>
